export enum MetricTypeEnum {
    Percentage = 1,
    Count = 2,
    Money = 3,
}

export enum SegmentTypeEnum {
    Dynamic = 0,
    Static = 1,
    Composite = 3,
}

export enum SortOrderEnum {
    ASC = 0,
    DESC = 1,
}

export enum SaveModesEnum {
    SaveAsLive = 'SaveAsLive',
    SaveAsDraft = 'SaveAsDraft',
}

export enum PageTypesEnum {
    create = 'create',
    clone = 'clone',
    edit = 'edit',
    predefined = 'predefined',
    view = 'view',
    execute = 'execute',
    convert = 'convert',
    delete = 'delete',
}

export enum DataTableConfigKeysEnum {
    dataTableCommunication = 'dataTableCommunication',
    dataTableCampaignCommunication = 'dataTableCampaignCommunication',
    dataTableWFCommunication = 'dataTableWFCommunication',
}

export enum LabelAppearanceEnum {
    None = 'none',
    Title = 'title',
    Swap = 'swap',
}

export enum FormatNumberActionEnum {
    DecimalPrecision = 'DecimalPrecision',
    CleanNumber = 'CleanNumber',
}

export enum DeliveryMethodEnum {
    Email = 0,
    Internal = 1,
    SMS = 2,
    PopUp = 3,
    Telegram = 4,
    PushNotification = 7,
    CMSPopUp = 8,
    Viber = 9,
    Hoory = 10,
    DynamicPopUp = 12,
    WhatsApp = 14,
    CMSBanner = 15,
    WhatsAppProvider = 16,
}

export enum DeviceTypeEnum {
    Mobile = 'MOBILE',
    Tablet = 'TABLET',
    Desktop = 'DESKTOP',
    FullScreen = 'FULL_SCREEN',
}

export enum DisplayModeEnum {
    LightMode = 'LIGHT_MODE',
    DarkMode = 'DARK_MODE',
}

export enum SpecialUiStyleEnum {
    Default = 'default',
    AI = 'ai',
}

export enum MenuItemIdTypeEnum {
    Number = 0,
    String = 1,
}

export enum SubscriptionSectionEnum {
    AIPoweredABTesting = 'AIPoweredABTesting',
    AISegmentationTool = 'AISegmentationTool',
    AiTemplateEditing = 'AiTemplateEditing',
    ClientTag = 'ClientTag',
    InstantWorkflow = 'InstantWorkflow',
    PromotionSchedulingTimeline = 'PromotionSchedulingTimeline',
    PersonalizedEventNotifications = 'PersonalizedEventNotifications',
    Predefined = 'Predefined',
    EfficiencyMetricsTracking = 'EfficiencyMetricsTracking',
    PromoBudget = 'PromoBudget',
    ExclusionRule = 'ExclusionRule',
    CustomFormula = 'CustomFormula',
    CampaignPrecalculation = 'CampaignPrecalculation',
    Notification = 'Notification',
    Achievement = 'Achievement',
}

export enum PermissionEnum {
    ViewTranslation = 'ViewTranslation',
    ManageUsers = 'ManageUsers',
    ViewCountries = 'ViewCountries',
    ViewCurrencies = 'ViewCurrencies',
    ViewPaymentTypes = 'ViewPaymentTypes',
    ViewClients = 'ViewClients',
    ViewPlayers = 'ViewPlayers',
    ViewLanguages = 'ViewLanguages',
    ViewMarkets = 'ViewMarkets',
    ViewUsers = 'ViewUsers',
    ManageClients = 'ManageClients',
    ManagePlayers = 'ManagePlayers',
    ViewClientProfiles = 'ViewClientProfiles',
    ManageClientProfiles = 'ManageClientProfiles',
    ViewDocuments = 'ViewDocuments',
    ViewSports = 'ViewSports',
    ViewOtherSportMarkets = 'ViewOtherSportMarkets',
    ViewPartnersBooking = 'ViewPartnersBooking',
    ManagePartnersBooking = 'ManagePartnersBooking',
    ViewWithdrawalRequests = 'ViewWithdrawalRequests',
    ManageWithdrawalRequests = 'ManageWithdrawalRequests',
    ManageChat = 'ManageChat',
    ViewAccount = 'ViewAccount',
    ManageAccount = 'ManageAccount',
    AllPartners = 'AllPartners',
    ViewSettings = 'ViewSettings',
    ManageSettings = 'ManageSettings',
    ManageClientMessage = 'ManageClientMessage',
    ViewClientMessage = 'ViewClientMessage',
    ViewMatch = 'ViewMatch',
    ViewRegions = 'ViewRegions',
    ViewCompetitions = 'ViewCompetitions',
    ViewAccountTurnover = 'ViewAccountTurnover',
    ViewBalance = 'ViewBalance',
    ViewReports = 'ViewReports',
    ViewDepositRequests = 'ViewDepositRequests',
    ManageDepositRequests = 'ManageDepositRequests',
    ViewPaymentTypesReport = 'ViewPaymentTypesReport',
    ManageClientBalance = 'ManageClientBalance',
    ViewClientBalance = 'ViewClientBalance',
    ViewClientAccounts = 'ViewClientAccounts',
    ViewBetReport = 'ViewBetReport',
    ViewBalanceReport = 'ViewBalanceReport',
    ViewGames = 'ViewGames',
    ManagePartnerMatchPackages = 'ManagePartnerMatchPackages',
    ViewPartnerMatchPackages = 'ViewPartnerMatchPackages',
    ViewClientTransactions = 'ViewClientTransactions',
    ViewClientLogins = 'ViewClientLogins',
    ViewClientSportBets = 'ViewClientSportBets',
    ViewClientCasinoBets = 'ViewClientCasinoBets',
    ViewOddsAdditionalCols = 'ViewOddsAdditionalCols',
    ViewClientLogHistory = 'ViewClientLogHistory',
    ViewOddsFeed = 'ViewOddsFeed',
    ManageOddsFeed = 'ManageOddsFeed',
    ViewAgentSubAccounts = 'ViewAgentSubAccounts',
    ManageAgentSubAccounts = 'ManageAgentSubAccounts',
    ViewDashBoardActivePlayers = 'ViewDashBoardActivePlayers',
    ViewDashBoardNewRegistrations = 'ViewDashBoardNewRegistrations',
    ViewDashBoardCasinoBets = 'ViewDashBoardCasinoBets',
    ViewDashBoardSportBets = 'ViewDashBoardSportBets',
    ViewDashBoardTopFiveGames = 'ViewDashBoardTopFiveGames',
    ViewDashBoardTopFiveMatches = 'ViewDashBoardTopFiveMatches',
    ViewDashBoardTopFivePlayers = 'ViewDashBoardTopFivePlayers',
    ViewDashBoardTopFiveSelections = 'ViewDashBoardTopFiveSelections',
    ViewMenuDashBoard = 'ViewMenuDashBoard',
    ViewAgentMembers = 'ViewAgentMembers',
    ManageAgentMembers = 'ManageAgentMembers',
    ViewAgentTransfers = 'ViewAgentTransfers',
    ManageAgentTransfers = 'ManageAgentTransfers',
    ViewAgentSystem = 'ViewAgentSystem',
    ManageAgentSystem = 'ManageAgentSystem',
    ViewCasinoReport = 'ViewCasinoReport',
    ViewCompetitionReport = 'ViewCompetitionReport',
    ViewMarketReport = 'ViewMarketReport',
    ViewPaymentReport = 'ViewPaymentReport',
    ViewSalesReport = 'ViewSalesReport',
    ViewSportReport = 'ViewSportReport',
    ViewMenuReport = 'ViewMenuReport',
    ViewAgentGroups = 'ViewAgentGroups',
    ManageAgentGroups = 'ManageAgentGroups',
    ViewAgentSummaryBalanceStatement = 'ViewAgentSummaryBalanceStatement',
    ViewAgentBettingReport = 'ViewAgentBettingReport',
    ViewAgentTransferReport = 'ViewAgentTransferReport',
    ManageSportLimits = 'ManageSportLimits',
    ViewAgentPtGroups = 'ViewAgentPtGroups',
    ViewAgentCommissionGroups = 'ViewAgentCommissionGroups',
    ViewAgentBetLimitGroups = 'ViewAgentBetLimitGroups',
    ManageAgentPtGroups = 'ManageAgentPtGroups',
    ManageAgentCommissionGroups = 'ManageAgentCommissionGroups',
    ManageAgentBetLimitGroups = 'ManageAgentBetLimitGroups',
    ViewAgentMenu = 'ViewAgentMenu',
    ViewAgentMarketReport = 'ViewAgentMarketReport',
    ViewCasino = 'ViewCasino',
    ViewTemplate = 'ViewTemplate',
    CreateTemplate = 'CreateTemplate',
    EditTemplate = 'EditTemplate',
    DeleteTemplate = 'DeleteTemplate',
    ViewSegment = 'ViewSegment',
    CreateSegment = 'CreateSegment',
    EditSegment = 'EditSegment',
    DeleteSegment = 'DeleteSegment',
    ViewCampaign = 'ViewCampaign',
    CreateCampaign = 'CreateCampaign',
    EditCampaign = 'EditCampaign',
    DeleteCampaign = 'DeleteCampaign',
    ExecuteCampaign = 'ExecuteCampaign',
    ViewOCampaign = 'ViewOCampaign',
    CreateOCampaign = 'CreateOCampaign',
    EditOCampaign = 'EditOCampaign',
    DeleteOCampaign = 'DeleteOCampaign',
    ExecuteOCampaign = 'ExecuteOCampaign',
    ViewAddHocReport = 'ViewAddHocReport',
    CreateAddHocReport = 'CreateAddHocReport',
    EditAddHocReport = 'EditAddHocReport',
    DeleteAddHocReport = 'DeleteAddHocReport',
    ExecuteAddHocReport = 'ExecuteAddHocReport',
    Create = 'Create Campaign',
    CreateGroup = 'CreateGroup',
    Delete = 'Delete AdHocReportResult',
    DeleteBonus = 'DeleteBonus',
    EditAdHocReportResult = 'EditAdHocReportResult',
    EditBonus = 'EditBonus',
    Execute = 'Execute Segment',
    ExecuteSegment = 'ExecuteSegment',
    ExecuteTemplate = 'ExecuteTemplate',
    ManageAddHocReport = 'ManageAddHocReport',
    ManageCampaign = 'ManageCampaign',
    ManageEmailTemplates = 'ManageEmailTemplates',
    ManageOCampaign = 'ManageOCampaign',
    ManageSegment = 'ManageSegment',
    ManageTemplate = 'ManageTemplate',
    ViewAdHocReportResult = 'ViewAdHocReportResult',
    ViewBonus = 'ViewBonus',
    ViewEmailTemplates = 'ViewEmailTemplates',
    ViewGroup = 'ViewGroup',
    ViewUser = 'ViewUser',
    AllDocuments = 'AllDocuments',
    ViewDashBoardTopFiveMatchesByStake = 'ViewDashBoardTopFiveMatchesByStake',
    ViewDashBoardTopFiveSportsbookPlayers = 'ViewDashBoardTopFiveSportsbookPlayers',
    ViewCMS = 'ViewCMS',
    ViewPopulars = 'ViewPopulars',
    MakeCorrection = 'MakeCorrection',
    ManageBonus = 'ManageBonus',
    ManagePopulars = 'ManagePopulars',
    ManualSettlement = 'ManualSettlement',
    ViewDashBoardBottomFiveMatches = 'ViewDashBoardBottomFiveMatches',
    ViewDashBoardBottomFiveSelections = 'ViewDashBoardBottomFiveSelections',
    BEViewCasinoBonus = 'BEViewCasinoBonus',
    BEViewSportBonus = 'BEViewSportBonus',
    BEManageCasinoBonus = 'BEManageCasinoBonus',
    BEManageSportBonus = 'BEManageSportBonus',
    ViewVerificationStep = 'ViewVerificationStep',
    ManageVerificationStep = 'ManageVerificationStep',
    ManageClientBonuses = 'ManageClientBonuses',
    ViewClientTurnoverReport = 'ViewClientTurnoverReport',
    ViewMatchTurnoverReport = 'ViewMatchTurnoverReport',
    ViewCashDeskReport = 'ViewCashDeskReport',
    ViewFutureLiveMatches = 'ViewFutureLiveMatches',
    ViewDailySalesReport = 'ViewDailySalesReport',
    PreMatchBets = 'PreMatchBets',
    AllMatches = 'AllMatches',
    BetShopBetsOnly = 'BetShopBetsOnly',
    ViewAffiliate = 'ViewAffiliate',
    AllBetshops = 'AllBetshops',
    ManageAgentRelationship = 'ManageAgentRelationship',
    ViewMarketTypeReport = 'ViewMarketTypeReport',
    ManageLoyaltyRates = 'ManageLoyaltyRates',
    ManageLoyaltyLevels = 'ManageLoyaltyLevels',
    ManageLoyaltyGameMultiplayers = 'ManageLoyaltyGameMultiplayers',
    ManageLoyaltyGameGroups = 'ManageLoyaltyGameGroups',
    ViewLoyaltyRates = 'ViewLoyaltyRates',
    ViewLoyaltyLevels = 'ViewLoyaltyLevels',
    ViewLoyaltyGameMultiplayers = 'ViewLoyaltyGameMultiplayers',
    ManageClientCredit = 'ManageClientCredit',
    ManageAgentCredit = 'ManageAgentCredit',
    AssignAgentCredit = 'AssignAgentCredit',
    ViewClientDocuments = 'ViewClientDocuments',
    ViewBetShopBets = 'ViewBetShopBets',
    ViewCashDeskShiftReport = 'ViewCashDeskShiftReport',
    SGPlayersView = 'SGPlayersView',
    SGPlayersEdit = 'SGPlayersEdit',
    SGChatView = 'SGChatView',
    SGTablesView = 'SGTablesView',
    SGTournamentsView = 'SGTournamentsView',
    SGTournamentsCreateEdit = 'SGTournamentsCreateEdit',
    SGNotificationsView = 'SGNotificationsView',
    SGNotificationsCreateEdit = 'SGNotificationsCreateEdit',
    SGStatisticsRake = 'SGStatisticsRake',
    SGStatisticsTournament = 'SGStatisticsTournament',
    SGGamesView = 'SGGamesView',
    SGPlayerBlock = 'SGPlayerBlock',
    SGPartnersView = 'SGPartnersView',
    SGPartnerCreate = 'SGPartnerCreate',
    SGTableCreateEdit = 'SGTableCreateEdit',
    SGStatisticsPlayer = 'SGStatisticsPlayer',
    SGTournamentTicketsCreate = 'SGTournamentTicketsCreate',
    ManageTriggeredCampaign = 'ManageTriggeredCampaign',
    ManagePushCampaign = 'ManagePushCampaign',
    ResetUserPassword = 'ResetUserPassword',
    AllowCmsSkinsListUse = 'AllowCmsSkinsListUse',
    ViewCmsSkins = 'ViewCmsSkins',
    ManageCmsSkins = 'ManageCmsSkins',
    ViewCmsSystemSettings = 'ViewCmsSystemSettings',
    ManageCmsSystemSettings = 'ManageCmsSystemSettings',
    ViewCmsSkinSettings = 'ViewCmsSkinSettings',
    ManageCmsSkinSettings = 'ManageCmsSkinSettings',
    ViewCmsGameProviders = 'ViewCmsGameProviders',
    ManageCmsGameProviders = 'ManageCmsGameProviders',
    ViewCmsGameCategories = 'ViewCmsGameCategories',
    ManageCmsGameCategories = 'ManageCmsGameCategories',
    ViewCmsGameFeatures = 'ViewCmsGameFeatures',
    ManageCmsGameFeatures = 'ManageCmsGameFeatures',
    ViewCmsGameThemes = 'ViewCmsGameThemes',
    ManageCmsGameThemes = 'ManageCmsGameThemes',
    ViewCmsAllGames = 'ViewCmsAllGames',
    ManageCmsAllGames = 'ManageCmsAllGames',
    ViewCmsSkinGames = 'ViewCmsSkinGames',
    ManageCmsSkinGames = 'ManageCmsSkinGames',
    ViewCmsJoinGames = 'ViewCmsJoinGames',
    ManageCmsJoinGames = 'ManageCmsJoinGames',
    ViewCmsGamesReference = 'ViewCmsGamesReference',
    ManageCmsGamesReference = 'ManageCmsGamesReference',
    ViewCmsSkinCategoriesProviders = 'ViewCmsSkinCategoriesProviders',
    ManageCmsSkinCategoriesProviders = 'ManageCmsSkinCategoriesProviders',
    ViewCmsSkinsProvidersReport = 'ViewCmsSkinsProvidersReport',
    ManageCmsSkinsProvidersReport = 'ManageCmsSkinsProvidersReport',
    ViewCmsMedias = 'ViewCmsMedias',
    ManageCmsMedias = 'ManageCmsMedias',
    ViewCmsPopups = 'ViewCmsPopups',
    ManageCmsPopups = 'ManageCmsPopups',
    ViewCmsBanners = 'ViewCmsBanners',
    ManageCmsBanners = 'ManageCmsBanners',
    ViewCmsNews = 'ViewCmsNews',
    ManageCmsNews = 'ManageCmsNews',
    ViewCmsPromotions = 'ViewCmsPromotions',
    ManageCmsPromotions = 'ManageCmsPromotions',
    ViewCmsPages = 'ViewCmsPages',
    ManageCmsPages = 'ManageCmsPages',
    ViewCmsBackgrounds = 'ViewCmsBackgrounds',
    ManageCmsBackgrounds = 'ManageCmsBackgrounds',
    ViewCmsLiveCasinoBuilder = 'ViewCmsLiveCasinoBuilder',
    ManageCmsLiveCasinoBuilder = 'ManageCmsLiveCasinoBuilder',
    ViewCmsSkinPayments = 'ViewCmsSkinPayments',
    ManageCmsSkinPayments = 'ManageCmsSkinPayments',
    ViewCmsAvailableSystemSettings = 'ViewCmsAvailableSystemSettings',
    ViewCmsAvailableSkinSettings = 'ViewCmsAvailableSkinSettings',
    ManageCmsAvailableSkinSettings = 'ManageCmsAvailableSkinSettings',
    ViewCmsCustomCss = 'ViewCmsCustomCss',
    ManageCmsCustomCss = 'ManageCmsCustomCss',
    ViewCmsLogo = 'ViewCmsLogo',
    ManageCmsLogo = 'ManageCmsLogo',
    ViewCmsProducts = 'ViewCmsProducts',
    ManageCmsProducts = 'ManageCmsProducts',
    ViewPromoCodes = 'ViewPromoCodes',
    ViewClientPromoCodes = 'ViewClientPromoCodes',
    ManageWorkflow = 'ManageWorkflow',
    ViewWithdrawDepositInfo = 'ViewWithdrawDepositInfo',
    Viewmaskedemail = 'Viewmaskedemail',
    ViewClientContacts = 'ViewClientContacts',
    ViewBetFightsDashboard = 'ViewBetFightsDashboard',
    ViewClientNote = 'ViewClientNote',
    DeleteClientNote = 'DeleteClientNote',
    ManageClientNote = 'ManageClientNote',
    ViewFriendShip = 'ViewFriendShip',
    test = 'test',
    ManageNonMarketingCampaign = 'ManageNonMarketingCampaign',
    ViewMaskedPhone = 'ViewMaskedPhone',
    ManageNonCustomer = 'ManageNonCustomer',
    ViewCustomReport = 'ViewCustomReport',
    ExecuteCustomReport = 'ExecuteCustomReport',
    CRMAdmin = 'CRMAdmin',
    CRMManager = 'CRMManager',
    ViewEventNotifications = 'ViewEventNotifications',
    ViewAwards = 'ViewAwards',
    ViewWorkflow = 'ViewWorkflow',
    CreateWorkflow = 'CreateWorkflow',
    EditWorkflow = 'EditWorkflow',
    DeleteWorkflow = 'DeleteWorkflow',
    ExecuteWorkflow = 'ExecuteWorkflow',
    ManageFreeBetBalance = 'ManageFreeBetBalance',
    ViewExclusionRule = 'ViewExclusionRule',
    CreateExclusionRule = 'CreateExclusionRule',
    EditExclusionRule = 'EditExclusionRule',
    DeleteExclusionRule = 'DeleteExclusionRule',
    ViewAchievement = 'ViewAchievement',
    DeleteAchievement = 'DeleteAchievement',
    CRMApproveRequest = 'CRMApproveRequest',
    CRMApproveSelfRequest = 'CRMApproveSelfRequest',
}

export enum MenuItemIdEnum {
    CJCurrencyList = 6,
    PopUpNotification = 84,
    Currency = 104,
    BalanceTypes = 106,
    CMSPopUpNotification = 3005,
    ColumnInfoType = 3007,
    UIType = 3008,
    FieldType = 3010,
    ExportType = 3011,
    SegmantationCategory = 3012,
    SegmentFullList = 2002,
    SegmentKPISupportedFullList = 3013,
    ClassifierGroupId = 3634568,
    PartnerAccessUsers = 3070,
    WonderWheel = 3071,
    ConsiderLimits = 3073,
    RecipientsWithAccessToPartner = 3074,
    LinkTracker = 3082,
    TemplateCategory = 3634565,
    PaymentSystem = 29,
}

export enum TrackingModeEnum {
    None = 0,
    Allow = 1,
    AllowWithShortening = 2,
}

export enum LinkManagementSettingEnum {
    Tracking = 'isTracking',
    Shortening = 'isShortening',
    Channel = 'channel',
}

export enum CreatePopoverView {
    MainView = 'mainView',
    SegmentView = 'segmentView',
    TemplateView = 'templateView',
    CustomerJourneyView = 'customerJourneyView',
    AwardView = 'awardView',
    ReportView = 'reportView',
    SocialTemplateView = 'socialTemplateView',
    PredefinedCreateView = 'predefinedCreateView',
    PredefinedTemplateView = 'predefinedTemplateView',
    PredefinedSocialTemplateView = 'predefinedSocialTemplateView',
    PredefinedRealtimePromotionView = 'predefinedRealtimePromotionView',
}

export enum ObjectTypeEnum {
    Campaign = 0,
    Workflow = 1,
    Template = 2,
    Segment = 3,
    EmailProvider = 4,
    Report = 5,
    SmsProvider = 6,
    CompositeReport = 7,
    WorkflowReport = 8,
    Bonus = 9,
    ExclusionRule = 10,
    CustomFormula = 11,
}

export enum ObjectDefinitionTypeEnum {
    Regular = 0,
    Predefined = 1,
}

export enum SegmentClientsCountRequestEnum {
    CompositeSegment = 'compositeSegment',
    SegmentId = 'segmentId',
    Filter = 'filter',
}

export enum PromotionTypeEnum {
    Campaign = 1,
    CustomerJourney = 2,
    ActionCampaign = 6,
}

export enum ObjectTypeIdsEnum {
    Segment = 10019,
    Template = 10024,
    Campaign = 1004,
    RealtimePromotion = 10012,
    Report = 41,
    ObjectApproval = 10030,
}

export enum PartnerDateFormat {
    Date = 'partnerDateFormat',
    DateTime = 'partnerDateTimeFormat',
    DateTimeWithoutSeconds = 'partnerDateTimeWithoutSecondsFormat',
}

export enum TagAppearanceEnum {
    Simple = 'simple',
    Minimal = 'minimal',
    Outline = 'outline',
    Clean = 'clean',
    Light = 'light',
    Colored = 'colored',
}
